import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { getMarketCategories } from 'shared/src/api/marketService/getMarketCategories';
import type { GetMarketCategoriesResponse } from 'shared/src/api/marketService/getMarketCategories/types';

export const useMarketCategoriesQuery = (
  marketId: number,
  options?: Omit<
    UseQueryOptions<GetMarketCategoriesResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<GetMarketCategoriesResponse>({
    queryKey: queryKey.marketCategories(marketId),
    queryFn: () => getMarketCategories(marketId),
    ...options,
  });
};

